import { minLength } from '@guestyci/foundation/validators';

export const hasDigit = (errorText) => (value) => {
  const reg = new RegExp('[0-9]');
  return reg.test(value) ? '' : errorText || 'Password must contain at least 1 digit';
};

export const allowLowercase = (errorText) => (value) => {
  const reg = new RegExp(/(.*[a-z].*)/);
  return reg.test(value)
    ? ''
    : errorText || 'Password must contain at least 1 lower case letter';
};

export const allowUppercase = (errorText) => (value) => {
  const reg = new RegExp(/(.*[A-Z].*)/);
  return reg.test(value)
    ? ''
    : errorText || 'Password must contain at least 1 upper case letter';
};

export const allowSpecialChapter = (errorText) => (value) => {
  const reg = new RegExp(/(?=.*[-+_!@#$%^&*., ?])/);
  return reg.test(value)
    ? ''
    : errorText || 'Password must contain at least 1 special character';
};

export const complexPasswordValidation = (value) => {
  const notValid = [
    minLength(8)(value),
    allowUppercase()(value),
    allowLowercase()(value),
    hasDigit()(value),
    allowSpecialChapter()(value),
  ].some((valid) => valid);

  return !notValid
    ? ''
    : 'Password must be at least 8 characters and include at least 1 lowercase letter, uppercase letter, number, and symbol';
};

export function isChecked(value) {
  if (!value) {
    return 'This field is required';
  }

  return '';
}

export default {};
